import { render } from "./index.vue?vue&type=template&id=63329d61&scoped=true&bindings={}"
import script from "./playlist-splitter.js?vue&type=script&lang=js"
export * from "./playlist-splitter.js?vue&type=script&lang=js"

import "./playlist-splitter.scss?vue&type=style&index=0&id=63329d61&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-63329d61"

export default script